<template>
  <v-container class="pa-0"
               fluid>
    <v-row no-gutters>
      <v-col :cols="isPhoneBool ? 12 : 4"
             class="border-right">
        <v-row no-gutters
               :class="TemplateOperator ? 'border-bottom' : null">
          <slot name="static-content" />
        </v-row>
        <slot name="option-list"
              v-if="TemplateOperator">
        </slot>
      </v-col>

      <v-col :cols="isPhoneBool ? 12 : 8"
             class="border-top">
        <div v-if="!TemplateOperator"
             class="d-flex flex-column justify-space-evenly"
             style="height: 100%">
          <slot name="option-list" />
        </div>
        <div v-else
             class="flowinto"
             style="height: 100%;">
          <slot name="main-content"
                :operator="TemplateOperator">

          </slot>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
export default {
  name: "CustomerCard2Layout",
  model: {
    prop: "TemplateOperator",
    event: "TemplateChange",
  },
  props: ["TemplateOperator"],
  components: {},
  mixins: [],

  data() {
    return {};
  },

  mounted() {},

  methods: {},

  computed: {},

  watch: {},
};
</script>

<style lang="scss">
.border-right {
  border-right: 2px solid #f0f0f0;
}
.border-top {
  border-top: 2px solid #f0f0f0;
}
.border-bottom {
  border-bottom: 2px solid #f0f0f0;
}
.flowinto {
  background-color: var(--v-previewcolor-base) !important;
}
</style>